import React, { useState } from "react";
import { Checkbox, Space, Form, Input, Button } from "antd";
import { useConfig } from "../../../data/useConfig";
import { useFilters } from "../../../data/useFilters";

const FilterCheckbox = ({ filter, showLabel = false, onFiltersChange }) => {
  const { filterDirection } = useConfig();
  const { selectedFilters: currentFilters } = useFilters();

  const [checkboxFilter, setCheckboxFilter] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);

  const onInputChange = ({ target: { value } }) => {
    setCheckboxFilter(value);
  };

  const onCheckboxChange = (value) => {
    const selectedFilter = [{ name: [filter.facet], value }];
    setSelectedFilters(selectedFilter);
    setTimeout(() => setCheckboxFilter(""), 2000);
  };

  let filterValues = filter.values ? Object.values(filter.values) : [];
  filterValues = filterValues.filter((value) => value);

  return (
    <>
      {filterDirection !== "horizontal" && filterValues.length > 10 && (
        <Input
          onChange={onInputChange}
          placeholder={`Busque por ${filter.label}`}
          value={checkboxFilter}
          style={{ marginBottom: "20px" }}
        />
      )}
      <Form.Item
        name={filter.facet}
        label={showLabel && filter.label}
        key={`${filter.facet}-checkbox-form`}
      >
        <Checkbox.Group
          onChange={onCheckboxChange}
          style={{ maxHeight: "300px", overflowY: "auto", width: "100%" }}
        >
          <Space direction="vertical" style={{ rowGap: "0px" }}>
            {filterValues.map(([id, label], i) =>
              id &&
              (label || "")
                .toLowerCase()
                .includes(checkboxFilter.toLowerCase()) ? (
                <Checkbox
                  key={`${id}-checkbox`}
                  value={id}
                  style={{ marginBottom: "8px" }}
                >
                  {label}
                </Checkbox>
              ) : (
                <Checkbox
                  key={`${id}-checkbox`}
                  value={id}
                  style={{ display: "none" }}
                >
                  {label}
                </Checkbox>
              )
            )}
          </Space>
        </Checkbox.Group>
      </Form.Item>
      {console.log({ selectedFilters })}

      {(selectedFilters[0]?.value?.length > 0 ||
        currentFilters.find(({ name }) => name === filter.facet)) && (
        <Button
          onClick={() => onFiltersChange(selectedFilters, true)}
          style={{
            width: "100%",
            height: "30px",
            padding: 0,
            color: "#FFF",
            backgroundColor: "var(--bn-secondary-color)",
            borderRadius: "5px",
            fontSize: "14px",
          }}
        >
          Aplicar filtros
        </Button>
      )}
    </>
  );
};

export default FilterCheckbox;
